import Image from 'next/image';
import Link from 'next/link';
import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

interface StepIndicatorProps {
    stepNumber: number;
    showLogo?: boolean;
}

export default function StepIndicator({ stepNumber, showLogo = true }: StepIndicatorProps): JSX.Element {
    const stepContainerStyles = 'w-full flex flex-col items-center';

    const defaultCircleStyles =
        'flex items-center justify-center w-8 h-8 bg-gray-200 rounded-full text-gray-600 font-semibold';
    const selectedCircleStyles = 'bg-blue-700 text-white';

    const defaultTextStyles = 'm-2 text-center text-xs font-medium text-gray-600 whitespace-nowrap';
    const selectedTextStyles = 'font-bold text-gray-900 whitespace-nowrap';

    const defaultSeparatorStyles = 'w-full h-0.5 mb-8 bg-gray-200';
    const selectedSeparatorStyles = 'bg-blue-600';

    return (
        <div className="w-full mb-6 flex flex-col space-y-4">
            {showLogo && (
                <Link href="/" className="self-start">
                    <Image
                        height={36}
                        width={168.75}
                        src="https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/logos/unified/sb-logo.svg"
                        alt="Storyblocks"
                    />
                </Link>
            )}
            <div className="w-full self-center flex flex-row items-center justify-between">
                {/* First step */}
                <div className={stepContainerStyles}>
                    <div className={twMerge(defaultCircleStyles, stepNumber >= 1 && selectedCircleStyles)}>1</div>
                    <div className={twMerge(defaultTextStyles, stepNumber >= 1 && selectedTextStyles)}>
                        Create Account
                    </div>
                </div>
                <div className={twMerge(defaultSeparatorStyles, stepNumber >= 1 && selectedSeparatorStyles)}></div>

                {/* Second step */}
                <div className={stepContainerStyles}>
                    <div className={twMerge(defaultCircleStyles, stepNumber >= 2 && selectedCircleStyles)}>2</div>
                    <div className={twMerge(defaultTextStyles, stepNumber >= 2 && selectedTextStyles)}>Checkout</div>
                </div>
                <div className={twMerge(defaultSeparatorStyles, stepNumber >= 2 && selectedSeparatorStyles)}></div>

                {/* Third step */}
                <div className={stepContainerStyles}>
                    <div className={twMerge(defaultCircleStyles, stepNumber >= 3 && selectedCircleStyles)}>3</div>
                    <div className={twMerge(defaultTextStyles, stepNumber >= 3 && selectedTextStyles)}>
                        Customization
                    </div>
                </div>
            </div>
        </div>
    );
}
